<div #tooltip class="container" [class.is-open]="isOpen" [ngClass]="tooltipPosition" (click)="handleClicked($event)">
  <lib-icon-button #button class="tooltip-button" [icon]="icon"></lib-icon-button>
  <lib-bubble #bubble class="tooltip-bubble" [contentType]="contentType" [content]="content"></lib-bubble>
</div>
